import { CONTENT_PAGES } from './content.data.mjs';
import type { SeoPage } from './content.data.mjs';

export { CONTENT_PAGES };
export type { SeoPage };

export const comparePages: SeoPage[] = CONTENT_PAGES.filter((p) => p.kind === 'compare');
export const blogPages: SeoPage[] = CONTENT_PAGES.filter((p) => p.kind === 'blog');

export const pageBySlug = (kind: SeoPage['kind'], slug: string): SeoPage | undefined =>
  CONTENT_PAGES.find((p) => p.kind === kind && p.slug === slug);
